
export function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-black text-[#FFFCF3]">
      <div className="text-center">
        <div className="animate-spin h-8 w-8 border-t-2 border-[#089BDF] rounded-full mx-auto mb-4"></div>
        <p>Loading...</p>
      </div>
    </div>
  );
}
